export const PageDataState = {
    Searchs: {
        education_type_id: {
            type: 'select',
            id: 'education_type_id',
            label: 'ประเภท',
            value: '',
            placeholder: 'จังหวัด',
        },
        ministry_id: {
            type: 'select',
            id: 'ministry_id',
            label: 'สังกัด',
            value: '',
            placeholder: 'สังกัดกระทรวง',
        },
        province_id: {
            type: 'select',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            placeholder: 'จังหวัด',
        },
        th_name: {
            type: 'text',
            id: 'th_name',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        education_type_id: {
            type: 'select',
            id: 'education_type_id',
            label: 'ประเภทสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        academy_code: {
            type: 'text',
            id: 'academy_code',
            label: 'รหัสสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 10
            },
            error: { status: null, msg: '' }
        },
        th_name: {
            type: 'text',
            id: 'th_name',
            label: 'ชื่อสถานศึกษา (ภาษาไทย)',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        en_name: {
            type: 'text',
            id: 'en_name',
            label: 'ชื่อสถานศึกษา (ภาษาอังกฤษ)',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        personnel_num: {
            type: 'text',
            id: 'personnel_num',
            label: 'จำนวนบุคลากร',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 1,
                max: 5000
            },
            error: { status: null, msg: '' }
        },
        ministry_id: {
            type: 'select',
            id: 'ministry_id',
            label: 'สังกัดกระทรวง',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        office_department_id: {
            type: 'select',
            id: 'office_department_id',
            label: 'สังกัดงาน / กรม',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        office_division_id: {
            type: 'select',
            id: 'office_division_id',
            label: 'สังกัดสำนัก / กอง',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        education_area_id: {
            type: 'select',
            id: 'education_area_id',
            label: 'เขตพื้นที่การศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        executive: {
            type: 'text',
            id: 'executive',
            label: 'ผู้บริหาร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },        
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        coordinator_name: {
            type: 'text',
            id: 'coordinator_name',
            label: 'ผู้ประสานงาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        phone_number: {
            type: 'text',
            id: 'phone_number',
            label: 'เบอร์โทรศัพท์',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        fax: {
            type: 'text',
            id: 'fax',
            label: 'โทรสาร',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        founding_date: {
            type: 'text',
            id: 'founding_date',
            label: 'วันที่ก่อตั้ง',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        founding_year: {
            type: 'select',
            id: 'founding_year',
            label: 'ปีที่ก่อตั้ง',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        no: {
            type: 'text',
            id: 'no',
            label: 'เลขที่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        village_no: {
            type: 'text',
            id: 'village_no',
            label: 'หมู่ที่',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        alley: {
            type: 'text',
            id: 'alley',
            label: 'ซอย',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        road: {
            type: 'text',
            id: 'road',
            label: 'ถนน',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        region_id: {
            type: 'select',
            id: 'region_id',
            label: 'ภูมิภาค',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        province_id: {
            type: 'select',
            id: 'province_id',
            label: 'จังหวัด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 2,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        district_id: {
            type: 'select',
            id: 'district_id',
            label: 'เขต / อำเภอ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        subdistrict_id: {
            type: 'select',
            id: 'subdistrict_id',
            label: 'แขวง / ตำบล',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 6,
                maxLength: 6
            },
            error: { status: null, msg: '' }
        },
        latitude: {
            type: 'text',
            id: 'latitude',
            label: 'ละติจูด',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        longitude: {
            type: 'text',
            id: 'longitude',
            label: 'ลองจิจูด',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        website: {
            type: 'text',
            id: 'website',
            label: 'เว็บไซต์',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        bank: {
            type: 'text',
            id: 'bank',
            label: 'ธนาคาร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        account_number: {
            type: 'text',
            id: 'account_number',
            label: 'เลขที่บัญชี',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 10,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },        
        genAcademyCode: {
            type: 'text',
            id: 'genAcademyCode',
            label: 'เลขสำหรับออกหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 2,
                maxLength: 3
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {}
}